export default "/images/ba853477881da5c8e23b2f6b12884883.avif";